/**
 * Create a new user.
 */
export const createUser = async (userData) => {
  const response = await fetch(`/api/user`, {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(userData),
  });
  if (!response.ok) throw new Error("Failed to create user");
  return await response.json();
};

